import { MenuItem } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useUpdateUserStatusMutation } from 'src/api/contests/updateUserStatus';
import { useAppSearchParams } from 'src/hooks/useAppSearchParams';

export const MakeDeadAliveMenuItem = ({
  isUserAlive,
  openId,
  setIsUserAlive,
}: {
  isUserAlive: boolean;
  openId: number;
  setIsUserAlive: (isUserAlive: boolean) => void;
}) => {
  const { contestId } = useAppSearchParams();
  const { mutate } = useUpdateUserStatusMutation({
    contestId,
    isAlive: isUserAlive,
    userId: openId,
  });

  const updateStatus = async () => {
    setIsUserAlive(!isUserAlive);
    mutate();
  };

  return (
    <>
      <MenuItem onClick={() => updateStatus()}>
        <Iconify
          icon={
            isUserAlive
              ? 'eva:checkmark-circle-2-outline'
              : 'eva:close-circle-outline'
          }
          sx={{ mr: 2 }}
        />
        {isUserAlive ? 'Make Dead' : 'Make Alive'}
      </MenuItem>
    </>
  );
};
